import { AppConfig } from './app-config.interface';
import { UserData } from './user-data.interface';

export function getObjectFromJsonTag(tagId: string): any {
  const element = document.getElementById(tagId);
  return element ? JSON.parse(element.innerText) : {};
}

export function appConfigFromDomFactory(): AppConfig {
  return getObjectFromJsonTag('application-config') as AppConfig;
}

export function userDataFromDomFactory(): UserData {
  return getObjectFromJsonTag('user-data') as UserData;
}
